<template>
      <section class="home hidden-first" id="home">
        <div class="container">
          <div class="row hero-row h-100 align-items-center">
            <div class="hero-left-col col-lg-6 col-md-6">
              <div class="content">
                <h1>Tandarts Sint-Michielsgestel | Tandzorg Gestel | Nieuwe Patiënten Welkom</h1>
                <h2>Zorg zoals wij die zelf zouden willen ervaren</h2>
                <p>
                  Bij <strong>Tandzorg Gestel</strong> behandelen we u zoals we zelf ook behandeld willen worden: met zorg, aandacht en vakmanschap. 
                  Uw mondgezondheid is onze prioriteit, en wij zorgen ervoor dat u zich op uw gemak voelt, of u nu komt voor een controle, een behandeling of een stralende lach.
                </p>
                <h3>Waarom kiezen voor<br>Tandzorg Gestel?</h3>
                <ul class="list-homepage">
                  <li class="list-item-container"><span class="list-checkmark"><i class="fa-solid fa-check"></i></span><span class="list-item-text"><strong>Persoonlijke aandacht</strong></span></li>
                  <li class="list-item-container"><span class="list-checkmark"><i class="fa-solid fa-check"></i></span><span class="list-item-text"><strong>Moderne technieken</strong></span></li>
                  <li class="list-item-container"><span class="list-checkmark"><i class="fa-solid fa-check"></i></span><span class="list-item-text"><strong>Vaste behandelaar</strong></span></li>
                  <li class="list-item-container"><span class="list-checkmark"><i class="fa-solid fa-check"></i></span><span class="list-item-text"><strong>Online afspraak maken</strong></span></li>
                  <li class="list-item-container"><span class="list-checkmark"><i class="fa-solid fa-check"></i></span><span class="list-item-text"><strong>Nieuwe patiënten welkom!</strong></span></li>
                </ul>
                <div class="homepage-buttons">
                  <router-link to="/inschrijven" class="link-btn homepage-btn register-btn-mobile">Inschrijven</router-link>
                  <router-link to="/afspraak-maken" class="link-btn homepage-btn appointment-btn register-btn-mobile">Afspraak maken</router-link>
                </div>
              </div>
            </div>
            
            <!-- Right Column: Reviews + Image -->
            <div class="hero-visual col-lg-5 col-md-6">
              <div class="visual-stack">
                <figure class="hero-photo-card">
                  <img :src="introPhoto" alt="Team Tandzorg Gestel" class="hero-photo" loading="lazy">
                </figure>
                <div class="hero-review-row">
                  <div class="hero-inline-review">
                    <div class="reviews-widget-home">
                      <iframe
                        src="https://www.beetr.nl/widgets/tandartspraktijk/tandzorg-gestel"
                        width="100%"
                        height="260"
                        style="border: 0; overflow: hidden; background: transparent;"
                        loading="lazy"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="home-info-cards-row">
              <div class="snelterecht-home-badge">
                <a href="https://snelterecht.nl/" target="_blank" rel="noopener noreferrer" aria-label="Snelterecht website">
                  <img :src="snelterechtLogo" alt="Snelterecht logo" class="snelterecht-home-logo" loading="lazy">
                </a>
                <p>
                  Met Snelterecht vullen we vrijgekomen plekken in de agenda sneller op, zodat patiënten eerder terecht kunnen en de planning soepel doorloopt.
                </p>
              </div>
              <div class="hero-local-seo-content home-local-card">
                <p class="hero-local-description">Tandzorg Gestel in Sint-Michielsgestel verwelkomt patiënten uit de hele regio, waaronder Den Bosch, Vught, Haaren, Boxtel, Berlicum, Schijndel en Liempde. Wij combineren moderne tandheelkunde met persoonlijke aandacht en zorg zoals wij die zelf zouden willen ervaren.</p>
              </div>
            </div>

          </div>
        </div>
    </section>
</template>

<script>
import introPhoto from '@/assets/images/Intro.jpg'
import snelterechtLogo from '@/assets/images/snelterecht-logo.png'

export default {
    name: "HomeSection",
    data() {
      return {
        introPhoto,
        snelterechtLogo
      }
    },
    mounted(){
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show-first')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden-first')
      hiddenElements.forEach((el) => observer.observe(el))

      document.title = "Home - Tandzorg Gestel"
      // document.querySelector('meta[name="description"]').setAttribute("content", "Home pagina website milad.");
      
    }
}
</script>

<style scoped>
.hidden-first {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 1.5s;
}

.show-first {
  opacity: 1;
  transform: translateX(0);
}

.snelterecht-home-badge {
  margin: 0;
  padding: 0.8rem 0.9rem;
  border: 1px solid rgba(16, 123, 255, 0.12);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
  gap: 1.1rem;
}

.snelterecht-home-badge a {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  line-height: 0;
}

.snelterecht-home-logo {
  width: 150px;
  max-width: 150px;
  height: auto;
  display: block;
  flex-shrink: 0;
}

.snelterecht-home-badge p {
  margin: 0;
  font-size: 1.24rem;
  line-height: 1.55;
  color: var(--light-color);
  max-width: none;
}

.home-info-cards-row {
  margin-top: 1.2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.9rem;
  align-items: stretch;
}

.home-local-card {
  margin-top: 0;
}

/* Lieve Tandarts aankondiging styling */
.lieve-tandarts-announcement {
  background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%); /* mooiere gradient */
  border-bottom: 3px solid #00b8b8; /* mooiere accent kleur */
  padding: 1.2rem 0; /* iets meer padding voor ruimer gevoel */
  margin-top: 95px; /* meer ruimte onder navigatiebalk */
  margin-bottom: 0; /* geen negatieve margin meer */
  position: relative;
  box-shadow: 0 3px 6px rgba(0,0,0,0.1); /* iets meer schaduw voor depth */
}

.announcement-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.2rem; /* iets meer ruimte tussen elementen */
  flex-wrap: wrap;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto; /* center de content */
  padding: 0 2rem; /* padding voor mobiele apparaten */
}

.lieve-tandarts-logo {
  width: 45px; /* iets groter */
  height: 45px;
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1)); /* subtiele schaduw voor logo */
}

.announcement-content p {
  margin: 0;
  font-size: 1.7rem; /* iets groter voor betere leesbaarheid */
  color: #2c3e50; /* donkerder voor betere contrast */
  font-weight: 500; /* iets zwaarder */
  line-height: 1.4; /* betere line height */
}

.announcement-content strong {
  color: var(--blue);
  font-weight: 600;
}

@media(max-width: 768px) {
  .snelterecht-home-badge {
    padding: 0.9rem 1rem;
    display: flex;
    align-items: center;
    gap: 0.8rem;
  }

  .snelterecht-home-logo {
    width: 140px;
    max-width: 140px;
  }

  .snelterecht-home-badge p {
    margin-top: 0;
    font-size: 1.2rem;
    line-height: 1.6;
  }

  .home-info-cards-row {
    margin-top: 1.2rem;
    grid-template-columns: 1fr;
    gap: 0.9rem;
  }

  .lieve-tandarts-announcement {
    margin-top: 80px; /* aangepast voor mobiele navigatiebalk hoogte */
    margin-bottom: 0; /* geen negatieve margin op mobiel */
    padding: 1rem 0; /* iets minder padding op mobiel */
  }
  
  .announcement-content {
    flex-direction: column;
    gap: 0.8rem; /* minder ruimte op mobiel */
    padding: 0 1rem; /* minder padding op mobiel */
  }
  
  .announcement-content p {
    font-size: 1.4rem; /* aangepast voor mobiel */
    line-height: 1.3;
  }
}

/* Reviews widget in home sectie */
.reviews-column {
  display: flex;
  align-items: center;
  justify-content: center;
}

.reviews-widget-home {
  text-align: left;
  width: 100%;
  max-width: 300px;
  margin: 0;
}

.reviews-widget-home iframe {
  border-radius: 10px;
  box-shadow: none;
  width: 100%;
  max-width: 100%;
  min-height: 220px;
  background: transparent;
}

.hero-inline-review {
  margin-top: 0;
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.hero-review-row {
  width: 100%;
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1fr;
  align-items: stretch;
  gap: 0.9rem;
  margin-left: 0;
}

.hero-local-seo-content {
  min-width: 0;
  margin-top: 0;
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid rgba(16, 123, 255, 0.12);
  border-radius: 12px;
  padding: 0.8rem 0.9rem;
}

.hero-local-description {
  margin: 0;
  font-size: 1.24rem;
  line-height: 1.55;
  color: var(--light-color);
}

.hero-review-row .reviews-widget-home {
  max-width: 100%;
}

@media(max-width: 992px) {
  .reviews-column {
    order: 2;
    margin-top: 2rem;
  }
  
  .home-image {
    order: 3;
    margin-top: 2rem;
  }
  
  .content {
    order: 1;
  }
}

@media(max-width: 768px) {
  .reviews-widget-home iframe {
    min-height: 330px;
  }
}

.reviews-section {
  padding: 4rem 0;
  background: #f8f9fa;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 3rem;
  font-weight: 600;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
  
  .reviews-section {
    padding: 3rem 0;
  }
}

.home {
  background-image: linear-gradient(147deg, #f9fcff 0%, #dee4ea 74%);
  min-height: auto;
  padding-top: 10.5rem;
  padding-bottom: 2.5rem;
}
.hero-left-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.home .content {
  width: auto;
  display: block;
  padding: 0.5rem 0 0.5rem 2rem;
}
.home .content h3 {
  font-size: 2.25rem;
  color: black;
}
.home .content p {
  line-height: 1.75;
  font-size: 1.45rem;
  color: var(--light-color);
  max-width: 54ch;
  padding: 0.9rem 0;
}

.list-homepage {
  padding: 0;
  font-size: 1.38rem;
  color: #666666;
  list-style: none;
  margin-top: 0.1rem;
  margin-bottom: 0;
}
.list-item-container{
  display: flex;
}
.list-item-container:not(:last-child) {
  display: flex;
  padding-bottom: 8px;
  /* align-items: center; */
}
.list-checkmark {
  /* background-color: blue; */
  color: green;
  padding-right: 12px;
  /* display: inline-block; */
}

.homepage-btn {
  margin-top: 15px;
}

.homepage-buttons {
  display: none;
}

.register-btn-mobile {
  display: none;
}

.hero-row {
  justify-content: space-between;
  --bs-gutter-x: 2.25rem;
  row-gap: 1.25rem;
  margin-top: 0;
  padding-bottom: 1rem;
  min-height: auto;
  align-items: flex-start !important;
}

.hero-row .hero-left-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.hero-visual {
  display: flex;
  justify-content: flex-end;
}

.visual-stack {
  width: 100%;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 0;
}

.hero-photo-card {
  width: 100%;
  max-width: 560px;
  margin: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 12px 26px rgba(12, 35, 76, 0.16);
  position: relative;
  background: #ffffff;
}

.hero-photo {
  width: 100%;
  display: block;
  aspect-ratio: 16 / 10;
  object-fit: cover;
}

@media (max-width: 991px) {
  .home .content {
    width: auto;
    padding-top: 1rem;
  }
  .hero-row {
    margin-top: 0;
    row-gap: 1.4rem;
    --bs-gutter-x: 1.2rem;
  }
  .hero-row .hero-left-col {
    padding-right: 0;
  }
  .hero-visual {
    order: 2;
  }
  .visual-stack {
    max-width: 500px;
    margin: 0 auto;
  }

  .hero-photo-card {
    max-width: 500px;
  }

  .hero-inline-review {
    margin-top: 0;
    width: 100%;
    justify-content: center;
  }

  .hero-review-row {
    margin-top: 0.85rem;
    margin-left: 0;
    grid-template-columns: 1fr;
    gap: 0.7rem;
  }

  .hero-local-seo-content {
    margin-top: 0;
    width: 100%;
  }

  .hero-local-description {
    font-size: 1rem;
    line-height: 1.62;
    text-align: left;
  }

  .reviews-widget-home {
    max-width: 340px;
    margin: 0 auto;
  }
  .register-btn-mobile {
    display: inline-block;
    margin-right: 15px;
    flex: 1;
    min-width: 120px;
  }
  
  .homepage-buttons {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    margin-top: 15px;
  }
}
@media (max-width: 768px) {
  .home {
    padding-top: 7.2rem;
  }
  .home .content {
    width: auto;
    padding-top: 0.8rem;
  }
  .home .content h3 {
    font-size: 1.85rem;
  }
  .home .content p {
    font-size: 1.2rem;
    line-height: 1.65;
  }
  .list-homepage {
    font-size: 1.2rem;
  }

  .hero-photo {
    aspect-ratio: 16 / 10;
  }

  .reviews-widget-home iframe {
    min-height: 220px;
  }
}
@media (max-width: 450px) {
  .home .content h3 {
    font-size: 1.7rem;
  }
  .hero-row {
    margin-top: 0.6rem;
    row-gap: 1.2rem;
  }
  .homepage-buttons {
    flex-direction: column;
    gap: 0.8rem;
  }
  
  .register-btn-mobile {
    margin-right: 0;
    text-align: center;
  }
}

@media screen and (max-width: 768px) and (orientation: landscape) {
  .hero-row {
    margin-top: 2rem;
  }
  .home {
    background-color: #f9fcff;
    background-image: linear-gradient(147deg, #f9fcff 0%, #dee4ea 74%);
    min-height: auto;
  }
}

.content h1 {
  font-size: 2.85rem;
  color: var(--black);
  margin-top: 0.4rem;
  margin-bottom: 0.9rem;
  line-height: 1.1;
}

.content h2 {
  font-size: 2.15rem;
  color: var(--blue);
  margin-bottom: 1rem;
  font-weight: 600;
  line-height: 1.25;
}

.content h3 {
  font-size: 2rem;
  color: var(--black);
  margin: 1.6rem 0 0.9rem 0;
  line-height: 1.2;
}

@media (max-width: 768px) {
  .content h1 {
    font-size: 2rem;
  }
  
  .content h2 {
    font-size: 1.55rem;
  }
  
  .content h3 {
    font-size: 1.5rem;
  }
}

/* Lokale SEO content styling */
.local-seo-content {
  margin-top: 2rem;
  padding: 1.5rem;
  background: rgba(0, 184, 184, 0.05);
  border-left: 4px solid var(--blue);
  border-radius: 8px;
}

.local-description {
  margin: 0;
  font-size: 1.4rem;
  line-height: 1.6;
  color: var(--light-color);
}

.local-description strong {
  color: var(--blue);
  font-weight: 600;
}

.local-description em {
  color: var(--black);
  font-style: normal;
  font-weight: 500;
}

@media (max-width: 768px) {
  .local-seo-content {
    margin-top: 1.5rem;
    padding: 1rem;
  }
  
  .local-description {
    font-size: 1.3rem;
  }
}

@media (max-width: 991px) {
  .home {
    background-image: linear-gradient(147deg, #f9fcff 0%, #dee4ea 74%);
    min-height: auto;
    padding-top: 8.8rem;
    padding-bottom: 2rem;
  }
}

@media (max-width: 768px) {
  .home {
    padding-top: 9rem;
  }

  .content h1 {
    margin-top: 0;
    line-height: 1.2;
  }
}

@media (max-width: 450px) {
  .home {
    padding-top: 9.4rem;
  }
}
</style>